<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          @click.stop="dialog = true"
          text
          rounded
          class="ma-3"
          color="green darken-3"
          >ADD DAMAGES</v-btn
        >
      </template>
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
          max-width: 600px;
        "
      >
        <v-card-title>
          <span class="headline">
            ADD
            <span class="red--text">DAMAGE</span>
          </span>
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="onAddDamage" ref="form">
          <div>
            <v-card
              style="max-width: 500px"
              outlined
              tile
              rounded
              class="ma-auto"
              dense
            >
              <v-container fluid>
                <v-autocomplete
                  v-model="type"
                  clearable
                  autofocus
                  :search-input.sync="search"
                  :items="options"
                  hide-no-data
                  hide-selected
                  label="Search for an option"
                  dark
                  chips
                  outlined
                  color="#2E5473"
                  dense
                  filled
                  class="ma-auto"
                  style="max-width: 500px"
                ></v-autocomplete>
              </v-container>
              <!-- <v-card
                style="border: 2px solid black; width: auto;  overflow:auto;"
                class="ma-2"
                color="#E8E8E8"
              > -->
              <!-- <v-layout> -->
              <div class="ma-3">
                <v-expand-transition>
                  <div class="ma-auto" v-if="type">
                    <!-- <v-card
                      style="border: 2px solid black; width: auto;  overflow:auto;"
                      class="ma-2"
                      color="#E8E8E8"
                    > -->
                    <v-text-field
                      v-model="description"
                      label="Describe the Damage:"
                      color="#2E5473"
                      dense
                      filled
                      autofocus
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="providerName"
                      label="Provider Name:"
                      color="#2E5473"
                      dense
                      filled
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <!-- <v-autocomplete
                        v-model="providerName"
                        label="Provider Name:"
                        color="yellow lighten-2"
                        style="max-width: 500px"
                        class="ma-auto"
                        :items="providers"
                        item-text="providerName"
                        search-input
                        return-object
                      ></v-autocomplete> -->
                    <v-text-field
                      v-model="providerAddressLine1"
                      label="Provider Street Address:"
                      color="#2E5473"
                      dense
                      filled
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="providerCityStateZip"
                      label="Provider City, State and Zip:"
                      color="#2E5473"
                      dense
                      filled
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="providerPhone"
                      label="Provider Phone:"
                      color="#2E5473"
                      dense
                      filled
                      style="max-width: 500px"
                      class="ma-auto"
                      v-mask="phoneMask"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="providerFax"
                      label="Provider Fax:"
                      color="#2E5473"
                      dense
                      filled
                      style="max-width: 500px"
                      class="ma-auto"
                      v-mask="phoneMask"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="providerEmail"
                      label="Provider Email:"
                      color="#2E5473"
                      dense
                      filled
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="amount"
                      label="Damage Amount:"
                      color="#2E5473"
                      dense
                      filled
                      data-type="currency"
                      type="number"
                      prefix="$"
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="providerDatesOfService"
                      label="DATES OF SERVICE"
                      name="datesOfService"
                      validate-on-blur
                      required
                      id="datesOfService"
                      class="ma-2"
                      outlined
                      clearable
                      placeholder="MM/DD/YYYY - MM/DD/YYYY"
                      color="#2E5473"
                      dense
                      filled
                    ></v-text-field>

                    <v-text-field
                      v-model="payment"
                      label="Payment Made:"
                      color="#2E5473"
                      dense
                      filled
                      prefix="$"
                      data-type="currency"
                      type="number"
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="paidBy"
                      label="Paid By:"
                      color="#2E5473"
                      dense
                      filled
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="adjustment"
                      label="Balance Adjustment:"
                      color="#2E5473"
                      dense
                      filled
                      data-type="currency"
                      prefix="$"
                      type="number"
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="remainingBalance"
                      label="Remaining Balance:"
                      color="#2E5473"
                      dense
                      filled
                      data-type="currency"
                      prefix="$"
                      type="number"
                      style="max-width: 500px"
                      class="ma-auto"
                      outlined
                    ></v-text-field>
                    <!-- </v-card> -->
                  </div>
                </v-expand-transition>
                <!-- </v-layout> -->
              </div>
              <!-- </v-card> -->

              <!-- <input 
          label="Attachment"
          type="file" 
          style="display: none" 
          ref="fileInput"   
          multiple="multiple"
          @change="onFilePicked">
          <v-layout align-center
              justify-center ><v-btn raised color="primary" @click="pickFile">ATTACH EVIDENCE</v-btn></v-layout>-->
              <!-- <v-btn color="blue" @click="addFiles" v-if="attachmentFiles.length > 0">add files</v-btn> -->
              <!-- <progress value="0" max="100" id="uploader">0%</progress> -->
            </v-card>
          </div>
          <v-layout row class="mt-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              color="black"
              :disabled="!formIsValid"
              dark
              type="submit"
              >SUBMIT</v-btn
            >
            <v-spacer></v-spacer>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * this component creates damage items  in the database for the plaintiff that is selected in the ui
 */

import { mask } from "vue-the-mask";
// import slugify from "slugify";
// import * as moment from "moment";
import * as firebase from "firebase";

export default {
  props: ["matter", "user", "plaintiff"],
  directives: {
    mask
  },
  data() {
    return {
      // menu: false,
      dialog: false,
      // allowSave: false,
      search: null,

      options: [
        `repair or replaice property`,
        `past lost earnings`,
        `future lost earnings`,
        `out-of-pocket expense`,
        `medical expense`,
        `future medical expense`,
        `quality of life change`,
        `pain and suffering`
      ],
      type: null,
      amount: 0.0,
      description: null,
      providerName: null,
      providerAddressLine1: null,
      providerCityStateZip: null,
      providerPhone: null,
      providerFax: null,
      providerEmail: null,
      providerDatesOfService: null,
      payment: 0.0,
      paidBy: null,
      adjustment: 0.0,
      // remainingBalance: null,

      phoneMask: "(###) ###-####",
      dateMask: "##/##/####",

      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      providers: []
    };
  },
  computed: {
    formIsValid() {
      return this.type !== null;
    },
    remainingBalance() {
      let damageAmount = parseFloat(this.amount);
      let damagePayment = parseFloat(this.payment);

      let damageAdjustment = parseFloat(this.adjustment);
      return damageAmount - damagePayment - damageAdjustment;
    }
  },
  // watch: {
  //   menu(val) {
  //     val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
  //   }
  // },
  methods: {
    cancelDialog() {
      // this.menu = false;
      this.dialog = false;
      this.amount = null;
      this.description = null;
      this.providerName = null;
      this.providerAddressLine1 = null;
      this.providerCityStateZip = null;
      this.providerPhone = null;
      this.providerFax = null;
      this.providerEmail = null;
      this.providerDatesOfService = null;
      this.payment = null;
      this.paidBy = null;
      this.adjustment = null;
      // this.remainingBalance = null;
      this.type = null;
    },
    onAddDamage() {
      let damageAmount = parseFloat(this.amount);
      //if damageAmount is NaN
      // damageAmount is 0
      let damagePayment = parseFloat(this.payment);
      let damageAdjustment = parseFloat(this.adjustment);
      const damage = {
        type: this.type,
        //make currency before save
        amount: damageAmount,
        party: this.plaintiff.partySlug,
        description: this.description,
        providerName: this.providerName,
        providerAddressLine1: this.providerAddressLine1,
        providerCityStateZip: this.providerCityStateZip,
        providerPhone: this.providerPhone,
        providerFax: this.providerFax,
        providerEmail: this.providerEmail,
        datesOfService: this.providerDatesOfService,
        payment: damagePayment,
        paidBy: this.paidBy,
        adjustment: damageAdjustment,
        remainingBalance: this.remainingBalance,
        documentaryEvidence: []
      };

      console.log(damage);

      // let firmSlug = this.user.firmSlug;
      let matterSlug = this.matter.matterSlug;
      // let oldPlaintiff = this.viewingPlaintiff;
      // let editedPlaintiff = {
      //   ...this.plaintiff,
      //   additionalInfo: "additionalInfo"
      // };

      firebase
        .firestore()
        // .collection("firms")
        // .doc(firmSlug)
        .collection("matters")
        .doc(matterSlug)
        .update({
          damages: firebase.firestore.FieldValue.arrayUnion(damage)
        })
        //todo add provider to provider list within matter and within the plaintiff globally and within firm?
        //

        // .then(() => {
        //       console.log("delete success");
        //       firebase
        //         .firestore()
        //         .collection("firms")
        //         .doc(firmSlug)
        //         .collection("matters")
        //         .doc(matterSlug)
        //         .update({
        //           plaintiffs: firebase.firestore.FieldValue.arrayUnion(
        //             editedPlaintiff
        //           )
        //         })
        .then(() => {
          console.log("update success");
          if (this.providerName) {
            const provider = {
              providerName: this.providerName,
              providerAddressLine1: this.providerAddressLine1,
              providerCityStateZip: this.providerCityStateZip,
              providerPhone: this.providerPhone,
              providerFax: this.providerFax,
              providerEmail: this.providerEmail
            };
            let providerRef = firebase
              .firestore()
              .collection("providers")
              .doc(damage.providerName);
            let firmProviderRef = firebase
              .firestore()
              .collection("firms")
              .doc(this.user.firmSlug)
              .collection("providers")
              .doc(provider.providerName);
            firmProviderRef
              .get()
              .then(doc => {
                if (doc.exists) {
                  console.log("provider already in list");
                } else {
                  firmProviderRef.set(provider);
                }
              })
              .then(() => {
                providerRef
                  .get()
                  .then(doc => {
                    if (doc.exists) {
                      this.dialog = false;
                      this.amount = null;
                      this.description = null;
                      this.providerName = null;
                      this.providerAddressLine1 = null;
                      this.providerCityStateZip = null;
                      this.providerPhone = null;
                      this.providerFax = null;
                      this.providerEmail = null;
                      this.providerDatesOfService = null;
                      this.payment = null;
                      this.paidBy = null;
                      this.adjustment = null;

                      this.type = null;
                      return;
                    } else {
                      firebase
                        .firestore()
                        // .collection("firms")
                        // .doc(firmSlug)
                        .collection("providers")
                        .doc(damage.providerName)
                        .set(provider)
                        .then(() => {
                          this.dialog = false;
                          this.amount = null;
                          this.description = null;
                          this.providerName = null;
                          this.providerAddressLine1 = null;
                          this.providerCityStateZip = null;
                          this.providerPhone = null;
                          this.providerFax = null;
                          this.providerEmail = null;
                          this.providerDatesOfService = null;
                          this.payment = null;
                          this.paidBy = null;
                          this.adjustment = null;

                          this.type = null;
                        });
                    }
                  })
                  .catch(e => console.log(e));
              });
          }
        })
        .catch(e => console.log(e));
    }
  },
  created() {
    // let providers = [];
    firebase
      .firestore()
      .collection("providers")
      .get()
      .then(res => {
        res.forEach(doc => {
          let data = doc.data();
          this.providers.push(data);
        });
      })
      .catch(e => {
        console.log(e);
      });
  }
};
</script>

<style lang="scss" scoped></style>
